import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-3">
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择青柠影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为您打造极致的高清电影在线观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}